import "./Projects.scss";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import p1 from "../../../Assets/images/projects/naiet1.png";
import p2 from "../../../Assets/images/projects/Gaumukhi1.jpg";
import p3 from "../../../Assets/images/projects/FoodMahal1.jpg";
import p4 from "../../../Assets/images/projects/Multi-CulturalMuseum1.jpg";
import p5 from "../../../Assets/images/projects/batukbhairav.jpg";

const Projects = () => {
  const ourProjects = [
    {
      name: "Gaumukhi Primary Hospital",
      img: p2,
      bio: "A seasoned Geotechnical Engineer, Sandip ensures technical precision and project success from the ground up.",
    },
    {
      name: "Nepal Army Institute of Engineering Technology",
      img: p1,
      bio: "An MBA graduate, Aashma leads the organization with strategic insight and a focus on operational excellence.",
    },
    {
      name: "Modern Food Mahal",
      img: p3,
      bio: "As a Structural Design Engineer, Sagun specializes in delivering efficient and innovative structural solutions.",
    },
    {
      name: "SMulti-cultural Museum",
      img: p4,
      bio: "With a background in Structural Design Engineering, Radhesh ensures safe and reliable design execution.",
    },
    {
      name: "Batuk Bhairav Gale Park",
      img: p5,
      bio: "With a background in Structural Design Engineering, Radhesh ensures safe and reliable design execution.",
    },
  ];

  return (
    <div className="project-section">
      <div className="container">
        <div className="row">
          <div className="col-6">
            <div className="project-title">
              <motion.div
                initial={{ opacity: 0, x: -100 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.99, ease: "easeOut", delay: 0.2 }}
                viewport={{ once: true }}
              >
                <h2>Our Works</h2>
              </motion.div>

              <motion.div
                initial={{ opacity: 0, x: -100 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.99, ease: "easeOut", delay: 0.3 }}
                viewport={{ once: true }}
              >
                <h4>Innovative designs, lasting impressions</h4>
              </motion.div>
            </div>
          </div>
          <div className="col-6 project-btn-section">
            <Link to="/portfolio" className="project-btn">
              See more
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                height="15px"
                width="15px"
                className="project-icon"
              >
                <path
                  stroke-linejoin="round"
                  stroke-linecap="round"
                  stroke-miterlimit="10"
                  stroke-width="1.5"
                  stroke="#292D32"
                  d="M8.91016 19.9201L15.4302 13.4001C16.2002 12.6301 16.2002 11.3701 15.4302 10.6001L8.91016 4.08008"
                ></path>
              </svg>
            </Link>
          </div>
        </div>

        <div className="project-grid">
          {ourProjects.map((projects, index) => (
            <div className="project-card" key={index}>
              <motion.div
                className="card-inner"
                initial={{ opacity: 0, y: 0, filter: "blur(10px)" }}
                whileInView={{
                  opacity: 1,
                  y: 0,
                  filter: "blur(0px)",
                  transition: { duration: 0.6, delay: index * 0.3 },
                }}
                viewport={{ once: true }}
              >
                <div className="image-container">
                  <img src={projects.img} alt={projects.name} />
                </div>
                <div className="project-info">
                  <h3>{projects.name}</h3>
                </div>
              </motion.div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Projects;
